import { Schema } from '@effect/schema';
import { Address, ProtocolKey } from '@silo/types';

export const TermsOfUseAction = Schema.Literal('approve', 'deposit', 'borrow', 'withdraw', 'repay').annotations({
  identifier: 'TermsOfUseAction',
});

export type TermsOfUseAction = typeof TermsOfUseAction.Type;

export type PostAgreementBody = typeof PostAgreementBody.Type;
export type PostAgreementBodyEncoded = typeof PostAgreementBody.Encoded;

export const PostAgreementBody = Schema.Struct({
  protocolInstance: ProtocolKey,
  market: Address,
  action: TermsOfUseAction,
}).annotations({ identifier: 'PostAgreementBody' });

export type GetHasAgreedBody = typeof GetHasAgreedBody.Type;
export type GetHasAgreedBodyEncoded = typeof GetHasAgreedBody.Encoded;

export const GetHasAgreedBody = Schema.Struct({
  hasAgreed: Schema.Boolean,
}).annotations({ identifier: 'GetHasAgreedBody' });
